
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import SEOHead from '../../components/seo/SEOHead';
import { Link, useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ClothingStore",
    "name": "紳士服のミッキー",
    "description": "栃木県足利市にある個性派メンズファッション専門店。PANDIESTAをメインに、SINACOVA、BARNI VARNOも取り扱い。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
    "telephone": "0284-41-8666",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "相生町1-2",
      "addressLocality": "足利市",
      "addressRegion": "栃木県",
      "addressCountry": "JP"
    },
    "openingHours": "Mo-Su 09:30-18:00",
    "priceRange": "¥¥",
    "image": "https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/84853caa9907cfcb4be21b67f3d0531f.png",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "メンズファッション",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Product",
            "name": "PANDIESTA",
            "category": "メンズファッション"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Product",
            "name": "SINACOVA",
            "category": "メンズファッション"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Product",
            "name": "BARNI VARNO",
            "category": "メンズファッション"
          }
        }
      ]
    }
  };

  const brands = [
    {
      name: 'PANDIESTA',
      description: 'パンダをモチーフにしたユニークで個性的なデザインが特徴',
      image: 'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/fe925f5ddf5b8c88db44799c5a603232.png'
    },
    {
      name: 'SINACOVA',
      description: 'マリンテイストを基調とした上品で洗練されたデザイン',
      image: 'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/31ad607c80395565e908ed8287d754e6.jfif'
    },
    {
      name: 'BARNI VARNO',
      description: 'イタリアンテイストの洗練されたエレガントなブランド',
      image: 'https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/61d174ef248193f9e585249a8567b736.jfif'
    }
  ];

  const features = [
    {
      icon: 'ri-user-heart-line',
      title: '個別接客サービス',
      description: 'お客様一人ひとりの体型や好みに合わせて、専門スタッフが丁寧にご提案いたします。'
    },
    {
      icon: 'ri-shirt-line',
      title: '豊富な品揃え',
      description: 'PANDIESTAを中心に、個性的で魅力的なメンズファッションを幅広く取り揃えております。'
    },
    {
      icon: 'ri-map-pin-line',
      title: '地域密着50年',
      description: '足利市で長年愛され続ける老舗として、地域の皆様に信頼されるサービスを提供しています。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="紳士服のミッキー - 足利市の個性派メンズファッション専門店"
        description="栃木県足利市にある個性派メンズファッション専門店。PANDIESTAをメインに、SINACOVA、BARNI VARNOも取り扱い。実際に試着してお気に入りの一着を見つけてください。"
        keywords="紳士服,メンズファッション,PANDIESTA,SINACOVA,BARNI VARNO,足利市,個性的,試着"
        ogTitle="紳士服のミッキー - 足利市の個性派メンズファッション専門店"
        ogDescription="栃木県足利市にある個性派メンズファッション専門店。PANDIESTAをメインに、SINACOVA、BARNI VARNOも取り扱い。"
        ogImage="https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/84853caa9907cfcb4be21b67f3d0531f.png"
        structuredData={structuredData}
      />
      <Header />
      
      {/* ヒーローセクション */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/84853caa9907cfcb4be21b67f3d0531f.png')`
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-7xl font-bold mb-6" style={{ fontFamily: '"Pacifico", serif' }}>
              紳士服のミッキー
            </h1>
            <p className="text-xl md:text-2xl mb-4 font-medium">
              足利市で個性派ファッションをお探しなら
            </p>
            <p className="text-lg mb-8 max-w-3xl mx-auto leading-relaxed">
              PANDIESTAをメインブランドとして、SINACOVA、BARNI VARNOも取り扱う<br />
              個性的で魅力的なメンズファッション専門店です。<br />
              実際に試着してお気に入りの一着を見つけてください。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                type="button" 
                className="font-bold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap bg-gradient-to-r from-orange-500 to-red-5   0 text-white hover:from-orange-600 hover:to-red-600 shadow-lg hover:shadow-xl px-8 py-4 text-lg"
                onClick={() => navigate('/store')}
              >
                <i className="ri-map-pin-line mr-2"></i>
                店舗情報
              </button>
              <button 
                type="button" 
                className="font-bold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:from-purple-700 hover:to-pink-700 shadow-lg hover:shadow-xl px-8 py-4 text-lg"
                onClick={() => navigate('/inventory')}
              >
                <i className="ri-shirt-line mr-2"></i>
                在庫一覧
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 取扱ブランドセクション */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-6 text-gray-800">
              取扱ブランド
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              個性豊かな3つのブランドを取り揃えております
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {brands.map((brand, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <img 
                  src={brand.image} 
                  alt={brand.name}
                  className="w-full h-96 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-800" style={{ fontFamily: 'Arial, sans-serif' }}>{brand.name}</h3>
                  <p className="text-gray-600 mb-4">{brand.description}</p>
                  <div className="mt-4">
                    <button 
                      type="button"
                      className="font-bold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:from-purple-700 hover:to-pink-700 shadow-lg hover:shadow-xl px-4 py-2 text-sm"
                      onClick={() => navigate(`/inventory?brand=${brand.name}`)}
                    >
                      <i className="ri-archive-line mr-2"></i>
                      在庫を確認する
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* コンセプトセクション */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8 text-gray-800">
              紳士服のミッキーについて
            </h2>
            <div className="bg-white rounded-lg shadow-lg p-8 mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                当店は栃木県足利市に店舗を構え、個性的なメンズファッションを専門とする紳士服店です。
                PANDIESTAをメインブランドとして、他では見つからないユニークなデザインの服を豊富に取り揃えております。
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                お客様一人ひとりの個性を大切にし、実際に試着していただくことで、サイズ感や着心地を確認してからご購入いただけます。
                オンラインショッピングでは分からない質感や細部のディテイルも, 
                店舗でじっくりとご確認いただけます。
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                足利市およびその周辺地域の皆様に愛され続ける地域密着型の店舗として, 
                お客様の個性を最大限に引き出すファッションをご提案いたします。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 店舗情報セクション */}
      <section className="py-20 bg-cyan-500 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8">
              店舗情報
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="text-left">
                <h3 className="text-xl font-bold mb-4">紳士服のミッキー</h3>
                <div className="space-y-2 text-gray-100">
                  <p><i className="ri-map-pin-line mr-2"></i>栃木県足利市相生町1-2</p>
                  <p><i className="ri-phone-line mr-2"></i>0284-41-8666</p>
                  <p><i className="ri-time-line mr-2"></i>営業時間：AM9時30分 ～ PM6時00分</p>
                  <p><i className="ri-calendar-line mr-2"></i>定休日：年中無休</p>
                </div>
              </div>
              <div className="text-left">
                <h3 className="text-xl font-bold mb-4">アクセス</h3>
                <div className="space-y-2 text-gray-100">
                  <p>• 足利ICから車で約15分</p>
                  <p>• JR足利駅から徒歩12分</p>
                  <p>• 無料駐車場6台完備</p>
                </div>
              </div>
            </div>
            <div className="text-center">
              <button 
                type="button" 
                className="font-bold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap bg-gradient-to-r from-orange-500 to-red-500 text-white hover:from-orange-600 hover:to-red-600 shadow-lg hover:shadow-xl px-8 py-4 text-lg"
                onClick={() => navigate('/store')}
              >
                <i className="ri-map-pin-line mr-2"></i>
                店舗情報
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 特徴セクション */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              紳士服のミッキーの特徴
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              50年の歴史と経験で培った確かな目利きと、お客様一人ひとりに寄り添うサービスをご提供いたします。
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center p-8 bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
